/**
 * The following code is required to fix miscalculation of the Widget position after Liferay migration from 7.2 to 7.4.
 */
import { CONFIG, IWidgetPositionConfig } from './variables';

export const initWidgets = (configParam: IWidgetPositionConfig) => {
  const config = configParam ?? CONFIG;
  const xOffsetMenuRight = config.POSITION_X_OFFSET_MENU_RIGHT;
  const xOffsetMenuLeftSide = config.POSITION_X_OFFSET_MENU_LEFT_SIDE;
  const xOffsetMenuIndicatorStart = config.POSITION_X_OFFSET_MENU_INDICATOR_START;
  const yOffsetMenuRight = config.POSITION_Y_OFFSET_MENU_RIGHT;
  const yOffsetMenuLeftSide = config.POSITION_Y_OFFSET_MENU_LEFT_SIDE;
  const yOffsetMenuIndicatorStart = config.POSITION_Y_OFFSET_MENU_INDICATOR_START;
  const minimalPositionYOffset = config.MINIMAL_POSITION_Y_OFFSET;

  /**
   * This function is responsible to move the on menu popup overlay using the YUI-Node module.
   */
  const setNewPosition = function() {
    // The overlay div is accessed by the class name "yui3-widget-positioned", which is first created after first menu click.
    const overlayWidget = document.getElementsByClassName('yui3-widget-positioned');
    const overlayWidgetAsNode = document.querySelector('.yui3-widget-positioned');

    // if the HTML Element is available, then we can proceed
    if (!!overlayWidget && overlayWidget.length > 0) {
      // since the Typescript needs the definition file, otherwise the build will fail, we need to ignore the next line
      /* eslint-disable @typescript-eslint/ban-ts-comment */
      // @ts-ignore
      YUI().use('node', function(Y) {
        // get current position after creating the widget overlay
        const position = Y.one('#'.concat(overlayWidget[0].id)).getXY();

        // calculate the new position relative to the current position
        let newPosition;
        // this is the menu overlay for Widgets, e.g. 'Export & Import', 'Look-and-Feel Configuration', 'Permissions', etc.
        if (overlayWidgetAsNode.querySelector('.dropdown-menu.dropdown-menu-right.dropdown-menu-indicator-start')) {
          newPosition = [position[0] + xOffsetMenuIndicatorStart, position[1] + yOffsetMenuIndicatorStart];
          // this is the menu to add Widgets within the 'Webcontent-Anzeige' widget. The '+' icon is the trigger
        } else if (overlayWidgetAsNode.querySelector('.dropdown-menu.dropdown-menu-right')) {
          newPosition = [position[0] + xOffsetMenuRight, position[1] + yOffsetMenuRight];
          // this is the menu overlay for Widgets within the 'Webcontent-Anzeige' widget, e.g. 'Edit Webcontent', 'Edit Template', 'Permissions', etc.
        } else if (overlayWidgetAsNode.querySelector('.dropdown-menu.dropdown-menu-left-side')) {
          newPosition = [position[0] + xOffsetMenuLeftSide, position[1] + yOffsetMenuLeftSide];
        }
        // set the determined position of the overlay
        Y.one('#'.concat(overlayWidget[0].id)).setXY(getMinimalYValue(newPosition));
      });
    }
  };

  /**
   * This function is verifying the minimal value of the Y axis. The number '-190' is observed minimal.
   *
   * @param position Array with 2 numbers (x and y axis)
   */
  function getMinimalYValue(position: number[]) {
    let normalizedPosition;
    if (position.length === 2) {
      normalizedPosition = [position[0], position[1] < minimalPositionYOffset ? minimalPositionYOffset : position[1]];
    } else {
      normalizedPosition = position;
    }
    return normalizedPosition;
  }

  /**
   * Create MutationObserver and set up the callback function
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const initMutationObserver = new MutationObserver(function(mutations) {
    setNewPosition();
  });

  /**
   * This function is initializing the MutationObserver to start observing the DOM-Mutations.
   * Retrying, when the dom is not ready yet - the container is not an instance of HTML Node.
   */
  function addObserverIfDesiredNodeAvailable() {
    const container = document.documentElement || document.body;
    if (!container || !(container instanceof Node)) {
      //The node we need does not exist yet.
      //Wait 500ms and try again
      window.setTimeout(addObserverIfDesiredNodeAvailable, 500);
      return;
    }
    const config = { childList: true, subtree: true };
    initMutationObserver.observe(container, config);
  }

  /**
   * Initialize MutationObserver
   */
  addObserverIfDesiredNodeAvailable();
};
